import { Grid, GridProps, useTheme } from "@mui/material";
import React, { memo } from "react";
import { styles } from "../../resources/styles/Styles";

type TwoSplitLayoutProps = {
  half: any;
  next: any;
};

export const TwoSliptLayout = memo((props: TwoSplitLayoutProps & GridProps) => {
  const theme = useTheme();
  const globalStyles = styles(theme);

  return (
    <Grid {...props}>
      <Grid item xs={6} sm={6} md={6} className={globalStyles.flexColumnCenter}>
        {props.half}
      </Grid>
      <Grid
        item
        xs={6}
        sm={6}
        md={6}
        className={globalStyles.flexColumnCenter}
      >
        {props.next}
      </Grid>
    </Grid>
  );
});

type MocImageProps = {
  src?: any;
  className?: any;
  onClick?: any;
  options?: any;
};

export const MocImage = (props: MocImageProps) => (
  <img {...props} alt="images" />
);
